import { useEffect, useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";

function Navbar({ logo, brandName, links, buttonText }) {
  const [visible, setVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 20); // show after slight scroll
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${visible ? "show" : "hide"}`}>
      <Link to="/" className="logo">
        {logo && <img src={logo} alt="logo" />}
        <span>{brandName || ''}</span>
      </Link>

      {/* Hamburger menu button for mobile */}
      <button className="hamburger" onClick={toggleMobileMenu} aria-label="Toggle menu">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        {(links || []).map((link, index) => (
          <Link key={index} to={link.path || '/'} onClick={closeMobileMenu}>
            {link.label || ''}
          </Link>
        ))}

        <button className="nav-button" onClick={closeMobileMenu}>
          {buttonText || ''}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
